import {useSearchParamsCustom} from '@utils/searchparams.uitilites';

export const useLeadSourceParams = () => {
  const urlSearchParams = useSearchParamsCustom();

  const getLeadSourceParams = () => {
    const enquiryCategory = urlSearchParams.get('enquirycategory');
    const enquiryTrigger = urlSearchParams.get('enquirytrigger');
    const offer = urlSearchParams.get('offer');

    return {
      enquiryCategory: enquiryCategory ?? undefined,
      enquiryTrigger: enquiryTrigger ?? undefined,
      offerCode: offer ?? undefined,
    };
  };

  return {
    urlSearchParams,
    getLeadSourceParams,
  };
};
